var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6736 28.2548C34.0458 29.5055 34.1705 31.7568 32.6736 33.0075C31.4261 34.1332 29.5549 33.883 28.3074 32.7574L19.9494 24.2525L11.7162 32.6323C10.5934 33.883 8.72225 34.1332 7.47478 33.1326C5.97783 32.0069 5.85308 29.8807 7.10054 28.5049L15.5833 20L7.22529 11.6202C5.97783 10.4945 5.97783 8.49334 7.10054 7.24262C8.22326 5.9919 10.2192 5.9919 11.4667 7.11755L19.9494 15.6225L28.0579 7.36769C29.3054 6.11697 31.1766 5.86682 32.4241 6.8674C33.921 7.99305 34.0458 10.1193 32.7983 11.4951L24.3155 19.8749L32.6736 28.2548Z",
    fill: "#656565"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.bb6399fa705f4f5244c8c06d7939c53d.svg";
export { ForwardRef as ReactComponent };